const formatModelId = (id: string | null | undefined): string => (
  id
    ? id.replace(/-/g, '')
    : ''
)

export default formatModelId
